import React from 'react';
import { Card, CardContent, SxProps } from '@mui/material';

import { ReactComponent as FilledIcon } from './resources/rate.svg';
import { ReactComponent as EmptyIcon } from './resources/empty-rate.svg';

export interface IFeedbackStudent {
  _id: string;
  firstname: string;
  lastname?: string;
}

export interface IFeedbackTutor {
  _id: string;
  firstname: string;
  lastname?: string;
}

const rateIconSize = 30;
const rateIconProps = { width: rateIconSize, height: rateIconSize };
export const RateIcon = <FilledIcon {...rateIconProps} />;
export const EmptyRateIcon = <EmptyIcon {...rateIconProps} />;

export const defaultRatingStyles: SxProps = {
  '& .MuiRating-icon': {
    marginRight: '10px',
  },
};

export const CustomCardContent = ({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement => {
  return (
    <Card
      elevation={0}
      sx={{ backgroundColor: '#F1F5F9', borderRadius: '10px' }}
    >
      <CardContent style={{ padding: '14px' }}>{children}</CardContent>
    </Card>
  );
};
